import { Controller } from '@hotwired/stimulus';
import { Helpers } from '../helpers';

export default class LendingTimetableFormController extends Controller {
  static values = {
    issuanceDate: String
  };

  static targets = ['fieldsWrapper'];

  connect () {
    this.updateAllTermsValues({});
  }

  initProjectTermValues(event) {
    const { fieldset: term, previousFieldset: previousTerm } = event?.detail;

    const remainingCapitalBefore = parseFloat(
      previousTerm?.querySelector('input[id*=\'remaining_capital_end_of_period\']')?.value ||
        parseFloat(document.querySelector('#edit_project').dataset.projectAmount)
    );
    const totalPaidCapital = parseFloat(
      previousTerm?.querySelector('input[id*=\'total_paid_capital_end_of_period\']')?.value || 0.0
    );
    const totalPaidInterests = parseFloat(
      previousTerm?.querySelector('input[id*=\'total_paid_interests_end_of_period\']')?.value || 0.0
    );

    term.querySelector('input[id*=\'remaining_capital_beginning_of_period\']').value = remainingCapitalBefore;
    term.querySelector('input[id*=\'remaining_capital_end_of_period\']').value = remainingCapitalBefore;
    term.querySelector('input[id*=\'total_paid_capital_end_of_period\']').value = totalPaidCapital;
    term.querySelector('input[id*=\'total_paid_interests_end_of_period\']').value = totalPaidInterests;
  }

  updateAllTermsValues(event) {
    const terms = Array.from(
      this.element.querySelectorAll('div[data-nested-form-target=fieldsWrapper]:not([data-destroyed=true])')
    );

    terms.forEach((term, index) => {
      if (term.dataset.is_readonly === 'true') {
        return;
      }

      this.updateTotalAmountToPay(term, terms[index - 1]);
    })
  }

  updateTotalAmountToPay(term, previousTerm) {
    const remainingCapitalEndOfPeriodEl = term.querySelector('input[id*=\'remaining_capital_end_of_period\']');
    const totalPaidCapitalEndOfPeriodEl = term.querySelector('input[id*=\'total_paid_capital_end_of_period\']');
    const totalPaidInterestsEndOfPeriodEl = term.querySelector('input[id*=\'total_paid_interests_end_of_period\']');
    const totalAmountToPayEl = term.querySelector('input[id*=\'total_amount_to_pay\']');
    const paymentCapitalShareEl = term.querySelector('input[id*=\'payment_capital_share\']');
    const paymentInterestsShareEl = term.querySelector('input[id*=\'payment_interests_share\']');
    const numberOfDaysEl = term.querySelector('input[id*=\'number_of_days\']');
    const dueOnEl = term.querySelector('input[id*=\'due_on\']');
    const interestRateEl = term.querySelector('input[id*=\'interests_rate\']');

    const paymentCapitalShare = parseFloat(paymentCapitalShareEl.value || 0.0);
    const paymentInterestsShare = parseFloat(paymentInterestsShareEl.value || 0.0);
    const lateFees = parseFloat(term.querySelector('input[id*=\'late_fees\']').value || 0.0);
    const interestsRate = parseFloat(interestRateEl.value || 0.0);

    let numberOfDays = 0;
    let remainingCapitalBefore = 0.0;
    let totalPaidCapital = 0.0;
    let totalPaidInterests = 0.0;

    if (previousTerm) {
      remainingCapitalBefore = parseFloat(
        previousTerm.querySelector('input[id*=\'remaining_capital_end_of_period\']').value
      );
      totalPaidCapital = parseFloat(
        previousTerm.querySelector('input[id*=\'total_paid_capital_end_of_period\']').value
      );
      totalPaidInterests = parseFloat(
        previousTerm.querySelector('input[id*=\'total_paid_interests_end_of_period\']').value
      );

      const previousTermDueOnValue = previousTerm.querySelector('input[id*=\'due_on\']').value;
      numberOfDays = this.#computeDaysBetweenTwoDates(previousTermDueOnValue, dueOnEl.value);

      const errorNumberOfDaysParent = numberOfDaysEl.closest('li');
      const errorDueOnParent = dueOnEl.closest('li');
      errorNumberOfDaysParent.querySelectorAll('p.inline-errors').forEach(el => el.remove());
      errorDueOnParent.querySelectorAll('p.inline-errors').forEach(el => el.remove());

      if (numberOfDays < 0) {
        errorNumberOfDaysParent.classList.add('error');
        errorDueOnParent.classList.add('error');
        const errorNumberOfDayMessage = document.createElement('p');
        const errorDueOnMessage = document.createElement('p');
        errorNumberOfDayMessage.className = 'inline-errors';
        errorNumberOfDayMessage.textContent = numberOfDaysEl.dataset.onError;
        errorNumberOfDaysParent.appendChild(errorNumberOfDayMessage);
        errorDueOnMessage.className = 'inline-errors';
        errorDueOnMessage.textContent = dueOnEl.dataset.onError;
        errorDueOnParent.appendChild(errorDueOnMessage);
        numberOfDaysEl.form.querySelector('input[type=\'submit\']').disabled = true;
      } else {
        errorNumberOfDaysParent.classList.remove('error');
        errorDueOnParent.classList.remove('error');
        numberOfDaysEl.form.querySelector('input[type=\'submit\']').disabled = false;
      }
    } else {
      remainingCapitalBefore = parseFloat(document.querySelector('#edit_project').dataset.projectAmount);
      numberOfDays = this.#computeDaysBetweenTwoDates(this.issuanceDateValue, dueOnEl.value);
    }

    if (!isNaN(numberOfDays)) { numberOfDaysEl.value = numberOfDays; }

    totalAmountToPayEl.value = (
      (paymentCapitalShare + paymentInterestsShare + lateFees).toFixed(2)
    );
    term.querySelector('input[id*=\'remaining_capital_beginning_of_period\']').value = remainingCapitalBefore;
    remainingCapitalEndOfPeriodEl.value = remainingCapitalBefore - paymentCapitalShare;
    totalPaidCapitalEndOfPeriodEl.value = totalPaidCapital + paymentCapitalShare;
    totalPaidInterestsEndOfPeriodEl.value = totalPaidInterests + paymentInterestsShare + lateFees;

    const errorParent = paymentCapitalShareEl.closest('li');
    errorParent.querySelectorAll('p.inline-errors').forEach(el => el.remove());

    if (paymentCapitalShare > remainingCapitalBefore) {
      errorParent.classList.add('error');
      const errorMessage = document.createElement('p');
      errorMessage.className = 'inline-errors';
      errorMessage.textContent = paymentCapitalShareEl.dataset.onError;
      errorParent.appendChild(errorMessage);
      paymentCapitalShareEl.form.querySelector('input[type=\'submit\']').disabled = true;
    } else {
      errorParent.classList.remove('error');
      paymentCapitalShareEl.form.querySelector('input[type=\'submit\']').disabled = false;
    }

    if (!isNaN(interestsRate) && !isNaN(numberOfDays) && numberOfDays > 0) {
      this.#computeAndDisplayPaymentInterestsShareHint(
        remainingCapitalBefore,
        interestsRate,
        numberOfDays,
        paymentInterestsShareEl
      );
    }
  }

  #computeDaysBetweenTwoDates(date1, date2) {
    const oneDay = 1000 * 60 * 60 * 24;

    return Math.round((Date.parse(date2) - Date.parse(date1)) / oneDay);
  }

  #computeAndDisplayPaymentInterestsShareHint(
    remainingCapitalBefore, interestRate,
    numberOfDays, paymentInterestsShareEl
  ) {
    try {
      const share = parseFloat(paymentInterestsShareEl.value || 0.0).toFixed(2);
      const suggestedShare = ((remainingCapitalBefore * (interestRate / 100) * numberOfDays) / 365);
      const shareHintEl = paymentInterestsShareEl.closest('li').querySelector('p.inline-hints');
      const shareDefaultHint = paymentInterestsShareEl.dataset.defaultHint;
      const shareHintTitle = paymentInterestsShareEl.dataset.hintTitle;
      const tooLowHint = paymentInterestsShareEl.dataset.amountTooLowHint;
      const suggestedShareContent = `${shareHintTitle}
        <span class="font-semibold">
          ${Helpers.numberToCurrency(suggestedShare, 2)}
        </span>`;

      this.#updateHintElement(
        shareHintEl,
        suggestedShareContent,
        shareDefaultHint,
        tooLowHint,
        suggestedShare,
        share
      );
    } catch (error) {
      console.error('Error computing and displaying payment interests share hint:', error);
    }
  }

  #updateHintElement(hintEl, suggestedHint, defaultHint, tooLowHint, suggestedValue, value) {
    const isSuggestedValueEqualToValue = suggestedValue === value;
    const textColor = isSuggestedValueEqualToValue ? 'text-blue-400' : 'text-orange-400';
    hintEl.parentElement.classList.remove('error');
    hintEl.classList.remove('text-blue-400', 'text-orange-400', 'inline-errors');

    if (suggestedValue > 0) {
      if (suggestedValue.toFixed(2) > 0) {
        hintEl.classList.add(textColor);
        hintEl.innerHTML = suggestedHint;
      } else {
        hintEl.parentElement.classList.add('error')
        hintEl.classList.add('inline-errors');
        hintEl.innerHTML = tooLowHint;
      }
    } else {
      hintEl.innerHTML = defaultHint;
    }
  }
}
